import { render, staticRenderFns } from "./CustomerTimelineEvent.vue?vue&type=template&id=4d3374ee"
import script from "./CustomerTimelineEvent.vue?vue&type=script&lang=js"
export * from "./CustomerTimelineEvent.vue?vue&type=script&lang=js"
import style0 from "./CustomerTimelineEvent.vue?vue&type=style&index=0&id=4d3374ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports